import { compressImages } from '../utils/imageCompression';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from './firebaseService';

/**
 * Komprimerer et bilde client-side.
 * Benytter den sentrale komprimeringsmodulen.
 */
export async function compressImage(input: Blob | File): Promise<Blob> {
  const file = input instanceof File ? input : new File([input], 'photo.jpg', { type: 'image/jpeg' });
  const [compressed] = await compressImages([file]);
  return compressed;
}

/**
 * Laster opp et waypoint-bilde til Firebase Storage.
 * Returnerer download URL.
 */
export async function uploadWaypointPhoto(
  userId: string,
  waypointId: string,
  file: Blob | File
): Promise<string> {
  const compressed = await compressImage(file);
  const fileRef = ref(storage, `waypoint_photos/${userId}/${waypointId}.jpg`);
  const snap = await uploadBytes(fileRef, compressed, {
    contentType: 'image/jpeg',
  });
  return getDownloadURL(snap.ref);
}

/**
 * Sletter et waypoint-bilde fra Firebase Storage.
 */
export async function deleteWaypointPhoto(
  userId: string,
  waypointId: string
): Promise<void> {
  const fileRef = ref(storage, `waypoint_photos/${userId}/${waypointId}.jpg`);
  try {
    await deleteObject(fileRef);
  } catch (e: any) {
    // Ignorer "object-not-found" — bildet kan allerede være slettet
    if (e?.code !== 'storage/object-not-found') throw e;
  }
}
